var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo695(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AJPerri_logo_rgb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 190.997,
    height: 80,
    viewBox: "0 0 190.997 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AJPerri_RGB",
    transform: "translate(-4.63 -8.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5750",
    "data-name": "Group 5750",
    transform: "translate(4.63 8.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M190.956,8.646,9.209,10.364,4.63,10.41V88.6h191V8.6Z",
    transform: "translate(-4.63 -8.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5749",
    "data-name": "Group 5749",
    transform: "translate(4.626 4.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M96.881,49.358c2.44,0,3.036-.168,4.128-.995A6.215,6.215,0,0,0,103,43.385c0-3.758-2.388-6.193-6.123-6.193H94.389V49.363h2.492M85.08,32.37H99.865c7.719,0,12.495,4.429,12.495,11.506a9.849,9.849,0,0,1-4.082,8.465c-1.943,1.33-4.03,1.827-7.615,1.827H94.389v15.1H85.08V32.37Z",
    transform: "translate(-43.189 -23.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M137.78,32.37h20.96v4.978H147.083V48.138h11.055v4.978H147.083V64.293h12.05v4.978H137.78V32.37",
    transform: "translate(-65.418 -23.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M183.79,32.37h14.241c8.667,0,14.045,4.261,14.045,11.119,0,4.978-2.642,8.245-7.869,9.737l8.014,16.045h-10.4l-8.066-18.531a9.9,9.9,0,0,0,1.642.11c4.926,0,7.32-2.157,7.32-6.47,0-4.759-2.538-7.193-7.667-7.193H193.1v32.09H183.79V32.37",
    transform: "translate(-84.825 -23.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M239.986,32.37h14.241c8.661,0,14.039,4.261,14.039,11.119,0,4.978-2.637,8.245-7.869,9.737l8.014,16.045H258l-8.066-18.531a9.9,9.9,0,0,0,1.642.11c4.932,0,7.32-2.157,7.32-6.47,0-4.759-2.538-7.193-7.667-7.193h-1.943v32.09H239.98V32.37",
    transform: "translate(-108.526 -23.292)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1738",
    "data-name": "Rectangle 1738",
    width: 9.309,
    height: 36.901,
    transform: "translate(164.221 9.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M32.2,78.449l-1.625-5.487-1.55,5.487H32.2m-2.388-8.9h3.51l4.556,15.374H34.129L32.77,80.362h-4.3l-1.341,4.562H25.34Z",
    transform: "translate(-17.991 -38.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M53.729,92a1.53,1.53,0,1,1-2.989-.023,1.677,1.677,0,0,1,1.509-1.821A1.7,1.7,0,0,1,53.729,92",
    transform: "translate(-28.705 -47.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M64.518,69.55V79.784c0,3.435-1.6,5.3-4.574,5.3a8.658,8.658,0,0,1-1.625-.162V83.086c.3.023.468.023.653.023a1.69,1.69,0,0,0,1.735-1.035,5.055,5.055,0,0,0,.318-2.284V69.556h3.492",
    transform: "translate(-31.902 -38.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M75.879,92a1.53,1.53,0,1,1-2.989-.023A1.677,1.677,0,0,1,74.4,90.16,1.7,1.7,0,0,1,75.879,92",
    transform: "translate(-38.048 -47.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M133.937,106.435l-5.007-.046v3.533l5.007-.046v-3.44m-38.589-.364-5.99-.052V110.3l5.99-.058Zm-6.777-.064-6.482-.064v4.423l6.482-.064Zm20.52.2-5.99-.058v4.024l5.99-.058Zm19.052.179-5.3-.052v3.648l5.3-.052Zm-12.472-.116-5.794-.052v3.9l5.794-.058Zm6.383.058-5.6-.052v3.77l5.6-.052Zm-19.734-.185-6.187-.058v4.157l6.187-.058Zm-60.607-.572-7.759-.075v5.337l7.759-.075Zm31.836.3L66.68,105.8v4.712l6.869-.064ZM12.63,105.29v5.736l20.544-.2v-5.348Zm181.746,1.717L193.33,107v2.313l1.047-.006ZM49.964,105.643l-7.459-.069v5.175l7.459-.069Zm15.929.15-7.066-.069v4.863l7.066-.069Zm-7.852-.069-7.291-.069v5.019l7.291-.069Zm23.267.214-6.973-.064v4.568l6.973-.069Zm100.538.954-2.359-.023v2.579l2.359-.023Zm-3.145-.029-2.845-.029v2.648l2.845-.029Zm6.285.058-2.359-.023v2.521l2.359-.023Zm2.648.023-1.868-.017v2.457l1.868-.017Zm2.851.029-2.064-.017v2.405l2.064-.017Zm2.058.017-1.278-.012v2.353l1.278-.012Zm-17.473-.162-2.949-.029v2.718l2.949-.029Zm-35.542-.335-4.811-.046v3.423l4.811-.046Zm15.022.139-4.123-.04v3.128l4.123-.04Zm4.516.046-3.735-.035v3.036l3.735-.035Zm-9.425-.087-4.024-.04v3.221l4.024-.04Zm-4.811-.046-4.516-.046v3.319l4.516-.04Zm26.511.249-3.14-.029v2.793l3.14-.029Zm-8.049-.081-3.44-.029v2.949l3.44-.035Zm4.123.04-3.342-.029v2.868l3.342-.029Z",
    transform: "translate(-12.63 -54.05)",
    fill: "#0059a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M73.069,21.267l5.007.046V17.774l-5.007.046v3.446m38.589.364,5.99.058V17.4l-5.99.052Zm6.771.064,6.482.064V17.335l-6.482.058Zm-20.52-.2,5.99.058V17.532l-5.99.058Zm-19.046-.179,5.3.046V17.717l-5.3.052v3.55Zm12.466.116,5.794.058V17.6l-5.794.052Zm-6.383-.058,5.6.052v-3.77l-5.6.052v3.666Zm19.74.185,6.187.058V17.462l-6.187.058Zm60.6.578,7.754.075V16.878l-7.754.075Zm-31.836-.3,6.875.064V17.19l-6.875.064Zm40.382-4.973v5.348l20.544.2V16.67ZM12.63,20.694l1.047.012V18.393L12.63,18.4v2.29Zm144.412,1.365,7.465.069V16.953l-7.465.069Zm-15.929-.15,7.066.069V17.115l-7.066.069Zm7.852.075,7.291.069V17.04l-7.291.069Zm-23.267-.22,6.967.069V17.266l-6.967.064ZM25.16,20.81l2.359.023V18.254l-2.359.023V20.81Zm3.14.029,2.851.029V18.22l-2.851.029Zm-6.285-.058,2.359.023V18.283l-2.359.023v2.475Zm-2.648-.029,1.868.017V18.312l-1.868.017Zm-2.851-.023,2.064.017V18.341l-2.064.017Zm-2.058-.017,1.272.012V18.364l-1.272.012Zm17.473.162,2.949.029V18.185l-2.949.029Zm35.542.335,4.811.046V17.826l-4.811.046ZM52.451,21.07l4.123.04V17.983l-4.123.035Zm-4.516-.046,3.729.035V18.023l-3.729.035Zm9.425.093,4.024.035V17.93l-4.024.04Zm4.811.046,4.516.04V17.884l-4.516.04ZM35.66,20.908l3.145.035V18.15l-3.145.029Zm8.054.075,3.435.035V18.069l-3.435.029Zm-4.123-.035,3.342.029V18.11l-3.342.035Z",
    transform: "translate(-12.63 -16.67)",
    fill: "#e31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M142.383,132.947h-1.156v-3.539h-3.192v3.539H136.89V124.69h1.145v3.585h3.192V124.69h1.156Z",
    transform: "translate(-65.043 -62.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M149.856,125.118c0-.11.012-.237.023-.358h4.03v1.127h-2.9v2.434H153.9v1.116h-2.874v2.4H153.9v1.116h-4.024l-.012-5.678-.012-1.226v-.931Z",
    transform: "translate(-70.509 -62.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M160.833,125.286c.035-.1.064-.191.1-.289a2.054,2.054,0,0,1,.1-.237h1.029l3.036,8.187h-1.18l-.89-2.457h-2.885l-.838,2.457h-1.2l2.428-6.829c.04-.121.087-.243.139-.37Zm.862,1.4a2.46,2.46,0,0,1-.116-.526h-.023a2.351,2.351,0,0,1-.087.411c-.023.075-.162.48-.179.567l-.786,2.3h2.162l-.746-2.1a.633.633,0,0,0-.052-.133Z",
    transform: "translate(-73.993 -62.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M170.24,124.71h3.909v1.116H172.79v7.158H171.6V125.8H170.24Z",
    transform: "translate(-79.11 -62.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M180.2,124.73v8.234H179.01V124.73Z",
    transform: "translate(-82.809 -62.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M185.9,127.623c-.064-.1-.382-.613-.457-.729a1.768,1.768,0,0,1-.231-.468l-.1-.312-.023.023a2.959,2.959,0,0,1,.052.358c.012.2.029,1.116.052,1.272l.052,5.2h-1.1v-8.28h1.243l1.995,3.215c.075.11.15.237.231.347l1.041,1.654a11.646,11.646,0,0,1,.671,1.174l.023-.023a4.977,4.977,0,0,1-.127-1.318l-.04-5.059h1.168v8.28h-1.1Z",
    transform: "translate(-84.973 -62.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M203.731,126.631a2.75,2.75,0,0,0-2.2-1.075,2.873,2.873,0,0,0-2.59,1.764,3.143,3.143,0,0,0-.289,1.376,3.021,3.021,0,0,0,2.874,3.117,2.972,2.972,0,0,0,2.718-1.943h-3.637V128.6h4.955a4.016,4.016,0,1,1-3.961-4.227,3.859,3.859,0,0,1,3.469,2.255h-1.341Z",
    transform: "translate(-90.629 -62.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M217.38,132.355V124.89h7.095v7.465Z",
    transform: "translate(-98.993 -62.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M241.207,126.7a2.705,2.705,0,0,0-2.2-1.07,2.867,2.867,0,0,0-2.59,1.752,3.275,3.275,0,0,0-.278,1.284,3.019,3.019,0,0,0,2.9,3.151,2.693,2.693,0,0,0,2.082-.937h1.422a3.938,3.938,0,0,1-3.481,2.18,4.344,4.344,0,0,1,0-8.667,4.061,4.061,0,0,1,3.556,2.313h-1.411Z",
    transform: "translate(-106.434 -62.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M254.073,133.076a4.284,4.284,0,1,1,4-4.256,4.294,4.294,0,0,1-1.116,2.926A3.818,3.818,0,0,1,254.073,133.076Zm2.8-4.267a2.946,2.946,0,0,0-2.845-3.03,2.912,2.912,0,0,0-2.833,3.018,2.963,2.963,0,0,0,2.868,3.018,2.784,2.784,0,0,0,2.174-1.075A3.245,3.245,0,0,0,256.872,128.809Z",
    transform: "translate(-112.761 -62.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M270.123,133.076a4.284,4.284,0,1,1,4-4.256,4.294,4.294,0,0,1-1.116,2.926A3.8,3.8,0,0,1,270.123,133.076Zm2.8-4.267a2.946,2.946,0,0,0-2.845-3.03,2.912,2.912,0,0,0-2.833,3.018,2.958,2.958,0,0,0,2.862,3.018,2.784,2.784,0,0,0,2.174-1.075A3.147,3.147,0,0,0,272.927,128.809Z",
    transform: "translate(-119.531 -62.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M286.677,132.955H282.89V124.71h1.133V131.9h2.654Z",
    transform: "translate(-126.625 -62.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M292.751,124.73v8.234H291.56V124.73Z",
    transform: "translate(-130.282 -62.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M298.462,127.623c-.064-.1-.382-.613-.457-.729a1.963,1.963,0,0,1-.231-.468l-.093-.312-.023.023a2.959,2.959,0,0,1,.052.358c.012.2.029,1.116.052,1.272l.052,5.2h-1.1v-8.28h1.243l1.995,3.215c.075.11.15.237.231.347l1.041,1.654a11.64,11.64,0,0,1,.671,1.174l.023-.023a4.979,4.979,0,0,1-.127-1.318l-.04-5.059h1.168v8.28h-1.1Z",
    transform: "translate(-132.454 -62.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M316.277,126.631a2.75,2.75,0,0,0-2.2-1.075,2.873,2.873,0,0,0-2.59,1.764,3.144,3.144,0,0,0-.289,1.376,3.021,3.021,0,0,0,2.874,3.117,2.972,2.972,0,0,0,2.718-1.943h-3.643V128.6H318.1a4.016,4.016,0,1,1-3.961-4.227,3.859,3.859,0,0,1,3.469,2.255h-1.336Z",
    transform: "translate(-138.098 -62.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M117.19,132.355V124.89h7.095v7.465Z",
    transform: "translate(-56.733 -62.317)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5747",
    "data-name": "Group 5747",
    transform: "translate(2.215 62.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M18.744,124.67c.278.012.827.046.925.069A2.334,2.334,0,0,1,21.5,127.1a2.677,2.677,0,0,1-1.232,2.238,3.258,3.258,0,0,1-1.625.347l-1.029.012v3.261H16.46v-8.28h2.284Zm-.532,3.9c1.018,0,1.359-.11,1.636-.335a1.393,1.393,0,0,0,.509-1.116,1.34,1.34,0,0,0-1.37-1.353l-1.359.023v2.781h.584Z",
    transform: "translate(-16.46 -124.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M31.287,132.955H27.5V124.71h1.133V131.9h2.654Z",
    transform: "translate(-21.117 -124.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M37.239,129.954a4.951,4.951,0,0,0,.023.636,1.5,1.5,0,0,0,1.474,1.353,1.34,1.34,0,0,0,1.093-.538c.341-.411.341-.694.341-1.6V124.75h1.191v5.418a2.722,2.722,0,0,1-2.642,3,2.656,2.656,0,0,1-2.336-1.521,3.976,3.976,0,0,1-.278-2.1l.012-4.793h1.127v5.2Z",
    transform: "translate(-24.744 -124.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M52.494,130.524a3.917,3.917,0,0,1,.168.729h.023a2.487,2.487,0,0,1,.075-.457,6.8,6.8,0,0,1,.254-.746l2.029-5.319h1.781v8.245H55.657v-6.112c0-.324.012-.659.04-.971l-.023-.023-.075.324a7.87,7.87,0,0,1-.393,1.116l-2.2,5.655H52.3l-.162-.411-2.261-5.8a4.017,4.017,0,0,1-.254-.9l-.023.023.035,1.041.012.422v5.632H48.47V124.73h1.816l1.573,4.076.289.729Z",
    transform: "translate(-29.962 -124.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M68.283,124.73a3.629,3.629,0,0,1,1.272.191,2.2,2.2,0,0,1,1.37,2.11,1.779,1.779,0,0,1-.723,1.463,2.282,2.282,0,0,1,1.191,2.035,2.51,2.51,0,0,1-.723,1.764,2.607,2.607,0,0,1-2.024.659h-2.2V124.73Zm.341,3.382a1.191,1.191,0,0,0,.671-.145,1.079,1.079,0,0,0,.5-.925,1.068,1.068,0,0,0-.341-.815c-.306-.312-.613-.312-1.18-.312-.22,0-.445.012-.671.023v2.18h1.023Zm.052,3.643a1.6,1.6,0,0,0,.995-.2,1.218,1.218,0,0,0,.532-1.029,1.33,1.33,0,0,0-.572-1.151c-.33-.225-.613-.225-1.451-.225-.191,0-.37,0-.561.012v2.59h1.058Z",
    transform: "translate(-37.546 -124.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M78.441,124.73v8.234H77.25V124.73Z",
    transform: "translate(-42.101 -124.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M84.138,127.623c-.064-.1-.382-.613-.457-.729a1.769,1.769,0,0,1-.231-.468l-.1-.312-.023.023a2.961,2.961,0,0,1,.052.358c.012.2.029,1.116.052,1.272l.052,5.2h-1.1v-8.28h1.243l1.995,3.215c.075.11.15.237.231.347l1.041,1.654a11.645,11.645,0,0,1,.671,1.174l.023-.023a4.977,4.977,0,0,1-.127-1.318l-.04-5.059h1.168v8.28h-1.1Z",
    transform: "translate(-44.265 -124.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M101.967,126.631a2.75,2.75,0,0,0-2.2-1.075,2.873,2.873,0,0,0-2.59,1.764,3.143,3.143,0,0,0-.289,1.376,3.021,3.021,0,0,0,2.874,3.117,2.972,2.972,0,0,0,2.718-1.943H98.839V128.6h4.955a4.016,4.016,0,1,1-3.961-4.227,3.859,3.859,0,0,1,3.469,2.255h-1.336Z",
    transform: "translate(-49.917 -124.37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5748",
    "data-name": "Group 5748",
    transform: "translate(176.074 9.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M317.537,34.832v.173a.7.7,0,0,0,.156.515.827.827,0,0,0,.983-.012.63.63,0,0,0,.168-.451.72.72,0,0,0-.081-.382.574.574,0,0,0-.266-.2l-.717-.278a.9.9,0,0,1-.486-.358,1.074,1.074,0,0,1-.116-.515.919.919,0,0,1,.266-.682.937.937,0,0,1,.694-.266,1.047,1.047,0,0,1,.734.237.744.744,0,0,1,.26.578,1.565,1.565,0,0,1-.006.162h-.393a.774.774,0,0,0,.006-.121.524.524,0,0,0-.538-.509.624.624,0,0,0-.474.156.634.634,0,0,0-.145.463.494.494,0,0,0,.341.486l.63.243a1.248,1.248,0,0,1,.549.353.892.892,0,0,1,.145.544,1.1,1.1,0,0,1-.272.769,1.029,1.029,0,0,1-.8.289,1.06,1.06,0,0,1-.746-.254,1.049,1.049,0,0,1-.278-.8v-.139h.387Z",
    transform: "translate(-317.15 -32.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M321.76,32.53h.676l.781,3.047.775-3.047h.676V36h-.382V32.773L323.443,36h-.457l-.844-3.226V36h-.382Z",
    transform: "translate(-319.094 -32.443)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo695);
export default __webpack_public_path__ + "static/media/logo_695.9056656993ecde2db563841d831dde2a.svg";
export { ForwardRef as ReactComponent };